import React from 'react';
import { BlogLayout, PostCard } from '../components/blog/BlogLayout';
import { useSeo } from '../hooks/useSeo';
import { BLOG_POSTS } from '../constants/blogPosts';

export default function BlogIndexPage() {
  useSeo({
    title: 'Coastal Real Estate Blog | Virginia Beach & Outer Banks | Jess Sells East Coast',
    description: 'Market updates, seller stories and coastal lifestyle insights from Jessica Burnette, REALTOR® for Virginia Beach and the Outer Banks.',
    path: '/blog',
    jsonLd: null,
  });
  const [featured, ...rest] = BLOG_POSTS;

  return (
    <BlogLayout backTo="/" backLabel="Back to home">
      <section className="max-w-5xl mx-auto px-5 pt-8" data-testid="blog-index">
        <p className="text-xs font-bold tracking-[0.25em] uppercase text-gold-600 mb-3">Coastal Insights</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#143160] mb-10">From The Blog</h1>
        {featured && <PostCard post={featured} large headingLevel="h2" />}
        {rest.length > 0 && <div className="grid sm:grid-cols-2 gap-6 mt-8">{rest.map((p) => <PostCard key={p.slug} post={p} headingLevel="h2" />)}</div>}
      </section>
    </BlogLayout>
  );
}
